import { CommonResponse, TargetMenu } from 'models/common';
import axiosClient from 'utils/axiosClient';

const wizardService = {
  getTargetMenuWizardList(payload: { wizard_id?: number }): Promise<CommonResponse<TargetMenu[]>> {
    const url = '/target-menu-wizard';
    const params = new URLSearchParams();

    if (payload.wizard_id) {
      params.append('wizard_id', payload.wizard_id.toString());
    }

    const queryString = params.toString();
    const fullUrl = queryString ? `${url}?${queryString}` : url;

    return axiosClient.get(fullUrl);
  },
  addTargetMenuWizard(payload: { wizard_id: number; menu_ids: number[] }): Promise<CommonResponse<any>> {
    const url = '/target-menu-wizard';
    return axiosClient.post(url, payload);
  },
  deleteTargetMenuWizard(payload: { wizard_id: number; menu_ids: number[] }): Promise<CommonResponse<any>> {
    const url = '/target-menu-wizard';
    return axiosClient.delete(url, { data: payload });
  },
};

export default wizardService;
